export enum PaymentStatus {
    CREATED = "created",
    PAYMENT_STARTED = "payment_started",
    WAITING_FOR_CAPTURE = "waiting_for_capture",
    PAID = "paid",
    PAYMENT_ERROR = "payment_error",
    CANCELED = "canceled",
}

export const StatusText = {
    [PaymentStatus.CREATED]: "Ожидаем оплату",
    [PaymentStatus.PAYMENT_STARTED]: "Ожидаем подтверждение",
    [PaymentStatus.WAITING_FOR_CAPTURE]: "Подтверждено",
    [PaymentStatus.PAID]: "Подтверждено",
    [PaymentStatus.PAYMENT_ERROR]: "Ошибка оплаты",
    [PaymentStatus.CANCELED]: "Отмена",
} as const
